export const EXPERIMENT_FLAGS = "experiment-flags"

type CookieValue = string | Record<string, string>
export const getExperimentValue = (
  cookies: Partial<{ [key: string]: CookieValue }>,
  flag: string
): string | boolean | number | undefined => {
  const flags = getExperimentValues(cookies)

  if (flags && flag in flags) {
    if (!isNaN(flags[flag] as number)) {
      return Number(flags[flag])
    }
    return flags[flag]
  }
  return undefined
}

export const getExperimentValues = (
  cookies: Partial<{ [key: string]: CookieValue }>
): Record<string, number | string | boolean> | undefined => {
  if (!cookies || Object.keys(cookies).length === 0) return undefined

  try {
    const cookie = cookies[EXPERIMENT_FLAGS]

    if (!cookie) return undefined

    if (typeof cookie === "string") {
      return JSON.parse(decodeURIComponent(cookie))
    }

    // N.B: typeof 'object' values need to be stringified to be parsed.
    // This allows for using js-cookie value and interoperability between req objects and client-side.
    return JSON.parse(JSON.stringify(cookie))
  } catch (e) {
    console.error("Failed to parse experiment-flags cookie value")
  }
  return undefined
}

export enum ExperimentFlags {
  EXPERIMENT_USE_DISCOVERY_JOURNEY = "experiment-use-discovery-journey",
  GUEST_PRICE_V3 = "page-experiment-guest-price-v3",
  OOS_SIMILAR_TO_EXPERIMENT = "page-experiment-show-similar-to",
  PAGE_EXPERIMENT_CLOUDINARY_LOADER = "page-experiment-cloudinary-loader",
  PAGE_EXPERIMENT_CONSTRUCTOR_BROWSE = "page-experiment-constructor-browse",
  PAGE_EXPERIMENT_CONTENT_FOR_DISCOVERY_JOURNEY = "page-experiment-test-discovery-journey",
  PAGE_EXPERIMENT_OPENGATE = "page-experiment-opengate",
  PAGE_EXPERIMENT_PDP_WITH_OPEN_GATE_UI = "page-experiment-pdp-with-open-gate-ui",
  PAGE_EXPERIMENT_US_JOURNEY = "page-experiment-us-journey",
  PRODUCT_COMPARISON_EXPERIMENT_V3 = "experiment-product-comparison-v3",
  SHOW_FOR_YOU_PAGE = "show-for-you-page",
  SHOW_ORDER_IT_AGAIN_PAGE = "show-favourites-order-it-again",
  USE_ATBL_V2 = "use-atbl-v2",
  USE_BLOG_MINIFIED_DATA = "use-blog-minified-data",
  USE_FREE_SHIPPING_THRESHOLD = "experiment-use-free-shipping",
  USE_MEMBER_BENEFITS_PAGE = "experiment-use-member-benefits",
  USE_PROMO_CODE_EXPERIMENT = "use-promo-code-experiment",
  PAGE_EXPERIMENT_HIGHLIGHT_NAV_ITEM = "page-experiment-highlight-nav-item",
  PAGE_EXPERIMENT_FOR_YOU_RECOMMENDATIONS_MHP = "page-experiment-for-you-recommendations-mhp",
  USE_NEW_WISHLIST_DESIGN = "use-new-wishlist-design",
  PAGE_EXPERIMENT_PRODUCT_FIRST_PLUS = "page-experiment-product-first-plus",
  PAGE_EXPERIMENT_PRODUCT_FIRST_MINI = "page-experiment-product-first-mini",
  PAGE_EXPERIMENT_NEW_OG_MAPPING = "page-experiment-new-og-mapping",
  PAGE_EXPERIMENT_PROGRESSIVE_REGISTRATION_WITH_EXPRESS_CHECKOUT = "page-experiment-progressive-registration-with-express-checkout",
  PAGE_EXPERIMENT_HIDE_BLACK_BANNER = "page-experiment-hide-black-banner",
  SHOW_OIA_ON_SEARCH = "experiment-oia-on-search",
  SHOW_DIGIOH_POPUP = "show-digioh-popup",
  SHOW_ANNIVERSARY_GIFT_TEASER = "experiment-anniversary-gift-teaser",
  PAGE_EXPERIMENT_AUTOPLAY_VIDEO = "page-experiment-autoplay-video",
  SHOW_MEMBER_TENURE_FROM_UPS = "show-member-tenure",
}

export const PAGE_EXPERIMENT_PDP_WITH_OPEN_GATE_UI = {
  name: "page-experiment-pdp-with-open-gate-ui",
  values: {
    CONTROL: 0,
    VARIANT: 1,
    THROWAWAY_CONTROL: 2,
    THROWAWAY_VARIANT: 3,
  },
}

export const PAGE_EXPERIMENT_OPENGATE = {
  name: "page-experiment-opengate",
  values: {
    CONTROL: 0,
    THROWAWAY: 1,
    PLUS: 2,
    MINI: 3,
    PLUS_TAB: 4,
    MINI_TAB: 5,
  },
}

export const PAGE_EXPERIMENT_NEW_OG_MAPPING = {
  name: "page-experiment-new-og-mapping",
  values: {
    OFF: 0,
    ON: 1,
  },
}

export const PAGE_EXPERIMENT_PROGRESSIVE_REGISTRATION_WITH_EXPRESS_CHECKOUT = {
  name: "page-experiment-progressive-registration-with-express-checkout",
  values: {
    CONTROL: 0,
    VARIANT_WITH_DOB: 1,
    VARIANT_WITHOUT_DOB: 2,
    THROWAWAY_CONTROL: 3,
    THROWAWAY_VARIANT_WITH_DOB: 4,
    THROWAWAY_VARIANT_WITHOUT_DOB: 5,
  },
}
